export default "__VITE_ASSET__DKW_bkQs__"